import { getNumberOfOwnershipParks } from '../../../utils/parks/getters';
export const getParkNumbersForFilter = (selectedIdSet) => `${selectedIdSet.size} park${selectedIdSet.size > 1 ? 's' : ''} selected`;
export const getFilterSelectionString = (selectedParks) => {
    return selectedParks.size
        ? Array.from(selectedParks).length === getNumberOfOwnershipParks()
            ? 'All parks selected'
            : getParkNumbersForFilter(selectedParks)
        : '';
};
